import { MEMBERS_APP_ID, SANTA_MEMBERS_APP_ID } from '../constants/applications';
import { getApplicationConfig } from '../selectors/communities-context-selectors';
import { getCommunityId } from '../selectors/forum-data-selectors';
import forumNavigation from './navigation-provider/forum';
import forumWithMembersAppNavigation from './navigation-provider/forum-with-members-app';
import forumWithMembersAreaNavigation from './navigation-provider/forum-with-members-area';
import forumWithMembersAreaRemovedNavigation from './navigation-provider/forum-with-members-area-removed';

export const createNavigation = store => {
  const state = store.getState();
  if (getApplicationConfig(state, MEMBERS_APP_ID).isInstalled) {
    return forumWithMembersAppNavigation;
  } else if (getCommunityId(state)) {
    return forumNavigation;
  } else if (getApplicationConfig(state, SANTA_MEMBERS_APP_ID).isInstalled) {
    return forumWithMembersAreaNavigation;
  } else {
    return forumWithMembersAreaRemovedNavigation;
  }
};



// WEBPACK FOOTER //
// ./app/services/create-navigation.js